import React from 'react'
import MedicinesFormAdd from './components/MedicinesFormAdd';
import doctor_n from '../../assets/images/undraw_doctor_kw.svg'
import { Link } from 'react-router-dom';
function MedicinesAdd() {
  return (
    <section className="hero is-fullheight-with-navbar">
      <div className="hero-body">
        <div className="container">
          <Link to="/medicines"><h1 className='has-text-left mt-3'><i class="fas fa-arrow-circle-left"></i></h1></Link>
          <div className="columns is-vcentered">
            <div className="column is-5">
              <figure className="image">
                <img src={doctor_n} alt="Pipeline SVG" />
              </figure>
            </div>
            <div className="column is-7">
              <MedicinesFormAdd />
            </div>
          </div>
        </div>
      </div>


    </section>
  )
}

export default MedicinesAdd;
